import { useLazyQuery } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { GetAppointmentForChangeDeliveryMethodDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { changeDeliveryMethodState } from '~/state/partials/change_delivery_method_modal/atoms';

export const useFetchAppointment = () => {
  const { appointmentId, isOpen } = useAtomValue(changeDeliveryMethodState);
  const [getAppointment, { data, loading, called }] = useLazyQuery(
    GetAppointmentForChangeDeliveryMethodDocument,
    {
      fetchPolicy: 'network-only',
    },
  );
  const appointment = getNode(data, 'Appointment');

  useEffect(() => {
    if (appointmentId) {
      getAppointment({ variables: { id: appointmentId } });
    }
  }, [getAppointment, appointmentId, isOpen]);

  return {
    loading: loading || !called,
    appointment,
  };
};
